import RequestOTP from './RequestOTP';

export default RequestOTP;